module.exports = __webpack_public_path__ + "99ac3308dd8ee14f749f51538d0d5b9e.woff";


//////////////////
// WEBPACK FOOTER
// ./~/_iview@3.5.4@iview/dist/styles/fonts/ionicons.woff?v=3.0.0
// module id = 821
// module chunks = 9